import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { ApiService, Categories } from "@app/core/services/api/api.service";

type ContactSentToSoderbergForPropertyStatus = {
  contactId: string;
  eaOid: string;
  hasBeenSentToSoderbergPartners: boolean;
};

@Injectable()
export class SoderbergPartnerService {
  constructor(private readonly api: ApiService) {}

  getIntegrationIsEnabled(): Observable<boolean> {
    return this.api
      .get("soderberg-partners/is-enabled", {}, Categories.Integrations)
      .pipe(map((response: { enabled: boolean }) => response.enabled));
  }

  getSentLeadStatus(contactId: string, eaOid: string): Observable<boolean> {
    return this.api
      .get(
        `soderberg-partners/contact/${contactId}/for-property/${eaOid}/status`,
        {},
        Categories.Integrations
      )
      .pipe(
        map(
          (response: ContactSentToSoderbergForPropertyStatus) =>
            response.hasBeenSentToSoderbergPartners
        )
      );
  }

  sendLead(
    contactId: string,
    eaOid: string,
    comment: string
  ): Observable<void> {
    return this.api.post(
      `soderberg-partners/contact/${contactId}/for-property/${eaOid}/send-lead`,
      { comment },
      Categories.Integrations
    );
  }
}
